<div class="container-fluid bg-white p-5 mb-5 br-10">
    <mat-card-content>
        <div class="row">

            <div class="col-12">
                <h1>Listado de carteras</h1>
            </div>

            <div class="col-12 d-flex justify-content-between mt-4">
                <mat-form-field appearance="outline" class="rounded-input">
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput placeholder="Buscar por ID o Nombre" (keyup)="applyFilter($event)" #input>
                </mat-form-field>
                <button mat-flat-button class="custom-button-primary" type="button" (click)="createBag()">Crear</button>
            </div>

            <div class="col-12">
                <div class="table-responsive">
                    <table mat-table [dataSource]="dataSource" matSort>

                        <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear sortActionDescription="Ordenado por ID">ID</th>
                            <td mat-cell *matCellDef="let element" class="cursor-pointer" (click)="openBag(element.id)"> {{element.id}} </td>
                        </ng-container>

                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear sortActionDescription="Ordenado por Nombre">Nombre</th>
                            <td mat-cell *matCellDef="let element" class="cursor-pointer" (click)="openBag(element.id)"> {{element.name}} </td>
                        </ng-container>

                        <ng-container *ngIf="isAdmin" matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef>Acciones</th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <button mat-mini-fab class="button-mini-fab-error" (click)="removeCartera(element.id)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="progress">
                            <th mat-cell *matCellDef="let element"></th>
                            <td mat-header-cell *matHeaderCellDef [attr.colspan]="displayedColumns.length">
                                <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let myRowData; columns: displayedColumns"></tr>

                        <tr mat-header-row *matHeaderRowDef="['progress']; sticky: true" class="progress-row"></tr>

                        <ng-container *ngIf="!isLoading">
                            <tr class="mat-mdc-row" *matNoDataRow>
                                <td class="mat-mdc-cell text-center font-weight-500 loading-cell" [attr.colspan]="displayedColumns.length">
                                    No hay datos disponibles
                                </td>
                            </tr>
                        </ng-container>
                    </table>
                </div>
            </div>

            <div class="col-12 mt-3">
                <mat-paginator [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons aria-label="Seleccionar página">
                </mat-paginator>
            </div>
        </div>
    </mat-card-content>
</div>